import { useSelector } from "react-redux";

const useRoles = () => {
  const role = useSelector((state) => state.auth?.user?.role);

  return {
    readOnly: role === "READONLY",
    readWrite: role === "READWRITE",
    admin: role === "ADMIN"
  };
};

export default useRoles;

export const useUserType = () => {
  const user_type = useSelector((state) => state.auth?.user?.user_type);

  return {
    isAdmin: user_type === "ADMIN",
    isAuthority: user_type === "AUTHORITY",
    isAuthorityUser: user_type === "AUTHORITY_USER",
    isFrontUser: !["ADMIN", "AUTHORITY", "AUTHORITY_USER"].includes(user_type)
  };
};
